import config from '../../slicemachine.config.json';

/**
 * The Prismic repo this deployment reads: `mecheadless` on prod, the Slice
 * Machine default (`mecheadless-staging`) everywhere else.
 *
 * Kept out of `./client` so consumers can name the repo without pulling
 * `@prismicio/client` in with it — the PLP builds its `algoliaDebug` document
 * links from this, and importing the client module there would ship the whole
 * SDK to the browser. `PRISMIC_ENV` is server-side only, so this falls back to
 * the Slice Machine default in client-side code.
 */
export const repositoryName = process.env.PRISMIC_ENV || config.repositoryName;
